import { PartnerSidebarActions } from "./PartnerSidebarAction";

const initialState = {
  partnerSidebarLoading: false,
  partnerSidebarDtoList: [],
  partnerSidebarError: "",
};

const PartnerSidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case PartnerSidebarActions.GET_PARTNER_SIDEBAR_SUCCESS:
      return {
        ...state,
        partnerSidebarDtoList: action.payload?.dtoList ?? action.payload?.dto,
        partnerSidebarLoading: false,
      };

    case PartnerSidebarActions.GET_PARTNER_SIDEBAR_ERROR:
      return {
        ...state,
        partnerSidebarError: action.payload,
        partnerSidebarDtoList: [],
        partnerSidebarLoading: false,
      };

    case PartnerSidebarActions.GET_PARTNER_SIDEBAR_LOADING:
      return {
        ...state,
        partnerSidebarLoading: true,
      };

    default:
      return state;
  }
};

export default PartnerSidebarReducer;
